import { UserManager } from 'oidc-client-ts';
import React from 'react';
import { BrowserRouter, Redirect, Route, Switch } from 'react-router-dom';
import AuthenticationProvider from './core/services/AuthenticationProvider';
import { MainLayout } from './layout';
import { HomeRoute, LoginRoute, SignInCallbackRoute, SilentRefreshRoute } from './routes';
import { PrivateRoute } from './routes/PrivateRoute';

const App = (props: {userManager : UserManager}) => {
  return (
      <>
        <AuthenticationProvider>
          <BrowserRouter>
            <Switch>
              <PrivateRoute exact path="/" component={HomeRoute} layout={MainLayout} />
              <Route path="/signin" exact={true} component={LoginRoute} />
              <MainLayout>
                <Route exact path="/callback" component={SignInCallbackRoute} />
                <Route path="/silent-renew" component={SilentRefreshRoute} />
              </MainLayout>
              <Route render={() => <Redirect to='/error' />} />
            </Switch>
          </BrowserRouter>
        </AuthenticationProvider>
      </>
    );
}

export default React.memo(App);
